import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { useCurrentUser } from '@klp/auth';
import {
    MiljoprofilAccess,
    MiljoprofilRoutes,
} from '@klp/sustainability/config';

import {
    ByggDokumentList,
    ByggFakturaList,
    ByggOverview,
    ByggSakList,
} from '..';
import { BuildingTabs } from '../../classes';
import type { Bygg } from '../../classes';
import { ByggCalendarAccess, ByggRoutes } from '../../config';
import { ByggMoteromCalendar } from '../ByggCalendar/ByggMoteromCalendar';
import { ByggKunderList } from '../ByggKunder/views';

type Props = {
    bygg: Bygg;
};

export const ByggSingleRoutes = ({ bygg }: Props) => {
    const byggNummer = bygg.byggNummer;
    const { currentUser: user } = useCurrentUser();

    return (
        <Switch>
            <Route
                path={ByggRoutes.single(':byggNummer', BuildingTabs.overview)}
            >
                <ByggOverview bygg={bygg} />
            </Route>
            {ByggCalendarAccess(user) && (
                <Route
                    path={ByggRoutes.single(
                        ':byggNummer',
                        BuildingTabs.calendar,
                    )}
                >
                    <ByggMoteromCalendar byggNummer={byggNummer} />
                </Route>
            )}
            <Route
                path={ByggRoutes.single(':byggNummer', BuildingTabs.documents)}
            >
                <ByggDokumentList byggNummer={byggNummer} />
            </Route>
            <Route
                path={ByggRoutes.single(':byggNummer', BuildingTabs.invoices)}
            >
                <ByggFakturaList />
            </Route>
            <Route
                path={ByggRoutes.single(
                    ':byggNummer',
                    BuildingTabs.consumption,
                )}
            >
                <Redirect
                    to={
                        MiljoprofilAccess()
                            ? MiljoprofilRoutes.list(byggNummer)
                            : ByggRoutes.single(
                                  byggNummer,
                                  BuildingTabs.overview,
                              )
                    }
                />
            </Route>
            <Route
                path={ByggRoutes.single(':byggNummer', BuildingTabs.customers)}
            >
                <ByggKunderList byggNummer={byggNummer} />
            </Route>
            <Route
                path={ByggRoutes.single(':byggNummer', BuildingTabs.tickets)}
            >
                <ByggSakList byggNummer={byggNummer} />
            </Route>
        </Switch>
    );
};
